export default __webpack_public_path__ + "static/media/fridge1-after1-480w.0d95e8d8.avif";